/**
 * Animate percentage counters in multicolumn section from 0 to target value
 * when section comes into view
 */
(function () {
  const DURATION = 2000; // ms
  const EASING = t => 1 - Math.pow(1 - t, 3); // ease-out cubic

  function animateCounter(element, target) {
    const valueEl = element.querySelector('.multicolumn-counter__value');
    if (!valueEl || target <= 0) return;

    let startTime = null;
    const startValue = 0;

    function update(currentTime) {
      if (!startTime) startTime = currentTime;
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / DURATION, 1);
      const easedProgress = EASING(progress);
      const currentValue = Math.round(startValue + (target - startValue) * easedProgress);
      valueEl.textContent = currentValue;

      if (progress < 1) {
        requestAnimationFrame(update);
      } else {
        valueEl.textContent = target;
      }
    }

    requestAnimationFrame(update);
  }

  function initCounters() {
    const sections = document.querySelectorAll('.multicolumn');
    if (!sections.length) return;

    sections.forEach((section) => {
      const titleElements = section.querySelectorAll('.multicolumn-card__title--counter[data-counter-target]');
      if (titleElements.length === 0) return;

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            const sectionEl = entry.target;
            const titles = sectionEl.querySelectorAll('.multicolumn-card__title--counter[data-counter-target]');
            titles.forEach((titleEl) => {
              const target = parseInt(titleEl.dataset.counterTarget, 10);
              if (!isNaN(target)) {
                animateCounter(titleEl, target);
              }
            });
            observer.unobserve(sectionEl);
          });
        },
        { threshold: 0.2, rootMargin: '0px 0px -80px 0px' }
      );

      observer.observe(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCounters);
  } else {
    initCounters();
  }

  // Support for Shopify sections that load dynamically (e.g. Theme Editor)
  document.addEventListener('shopify:section:load', initCounters);
})();
